import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setInputError } from "../inputError/inputErrorSlice";
import { setMessage } from "../message/messageSlice";

const endPoint = process.env.REACT_APP_API_URL;

export const createDeposit = createAsyncThunk(
  "deposit/createDeposit",
  async ({ user }, thunkApi) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.post(`${endPoint}/deposits/`, { user }, config);
      return res;
    } catch (error) {
      console.log(error.response);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
);

export const updateDeposit = createAsyncThunk(
  "deposit/updateDeposit",
  async ({ user, id }, thunkApi) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const resp = await axios.put(
        `${endPoint}/deposits/${id}/`,
        {user},
        config
      );
      return resp;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
);

export const getDeposit = createAsyncThunk(
  "deposit/getDeposit",
  async ({ id }, thunkApi) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      const resp = await axios.get(`${endPoint}/deposits/${id}/`, config);
      return resp;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
);
